<template>
  <el-select
      v-model="valueModel"
      :multiple="multiple"
      :clearable="clearable"
      filterable
      remote
      reserve-keyword
      placeholder="请输入"
      :remote-method="remoteMethod"
      @change="setValue"
      size="small"
      :disabled="disabled"
      :loading="loading">
    <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
import request from "@/utils/requests";

export default {
  name: "RemoteSelect",
  props: {
    value: {
      type: String|Number|Array,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    searchField: {
      type: String|undefined,
      default: "search"
    },
    remoteUrl: {
      type: String,
    },
  },
  data() {
    return {
      options: [],
      loading: false,
      valueModel: ""
    }
  },
  watch:{
    value:{
      handler(v){
        this.valueModel = _.cloneDeep(v)
        if(!v){
          this.options = []
        }
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    async remoteMethod(query) {
      let that = this
      let search = _.debounce(async function (){
        let params = {
        }
        params[that.searchField?that.searchField:"search"] = query
        if (query !== '') {
          that.loading = true
          let res = await request.request({
            url: that.remoteUrl,
            method: "get",
            params
          })
          that.loading = false
          that.options = res.data.map(item=> {
            return {
              label: item[that.labelField],
              value: item[that.valueField],
            }
          })
        } else {
          that.options = []
        }
      }, 600)
      search()
    },
    setValue(v){
      this.$emit("input", v)
      this.$emit("change", v)
    }
  }
}
</script>

<style scoped>

</style>